import React from 'react';
import { Button, SparkIcon, TooltipTrigger } from '@spark';
import { handleCopy } from '@/shared/utils/helpers';

/**
 * Absolute-positioned copy control for text fields (top-right of a relative parent).
 */
export default function CopyFieldButton({ value }) {
    if (!value) return null;

    return (
        <div style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
            <TooltipTrigger text="Copy">
                <Button
                    variant="ghost"
                    size="small"
                    startIcon={<SparkIcon slug="copy" size="small" />}
                    onClick={() => handleCopy(value)}
                />
            </TooltipTrigger>
        </div>
    );
}
